module.exports = __webpack_public_path__ + "static/media/moth-collection-poster.4b405a02.png";